export enum VideoErrorType {
  InitializeServiceError,
  ConnectError,
  SpeakScriptError,
  ServerDisconnectedError,
  AutoplayError,
}

export interface VideoError {
  type: VideoErrorType;
}

export const VideoErrorDescriptions: Record<VideoErrorType, string> = {
  [VideoErrorType.InitializeServiceError]: 'Sorry, the video connection could not be initialized',
  [VideoErrorType.ConnectError]: 'Sorry, we could not connect to the video',
  [VideoErrorType.SpeakScriptError]: 'Sorry, we could not play your script',
  [VideoErrorType.ServerDisconnectedError]:
    'Your session has timed out due to inactivity. Please reconnect.',
  [VideoErrorType.AutoplayError]: "Sorry, the video hasn't started automatically",
};
